import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { StyleSheet } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import * as RNStyle from '../../../styles/rn';
var articleStatusStyle = {
  padding: 14,
  height: 120
};
var articleStatusContentStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  height: '100%',
  width: '100%',
  backgroundColor: '#f5f5f5'
};
var styles = CustomStyleSheet({
  article: {
    width: '100%'
  },
  'article-content': {
    paddingTop: 10,
    paddingHorizontal: 12,
    paddingBottom: 12,
    position: 'relative',
    overflow: 'hidden'
  },
  'article-title': {
    marginBottom: 2
  },
  'article-desc': {
    color: RNStyle.gray_3,
    fontSize: 14,
    marginBottom: 8
  },
  'article-first-element': {
    maxHeight: 110,
    overflow: 'scroll'
  },
  'button-container': {
    flexGrow: 0,
    backgroundColor: '#ffffff',
    paddingVertical: 12,
    opacity: 1
  },
  article__error: articleStatusStyle,
  article__loading: _objectSpread(_objectSpread({}, articleStatusStyle), {}, {
    backgroundColor: 'transparent'
  }),
  article__deleted: articleStatusStyle,
  'article__error-article-content': articleStatusContentStyle,
  'article__loading-article-content': articleStatusContentStyle,
  'article__deleted-article-content': articleStatusContentStyle,
  'article__error-image': {
    height: 30
  },
  'article__error-prompt': {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.26)',
    top: 3
  },
  'article__error-prompt-a': {
    color: '#4e9aef'
  },
  'article__loading-icon': {
    backgroundColor: 'transparent',
    width: 16,
    height: 16
  },
  'article-prompt-icon': {
    flexDirection: 'row',
    alignItems: 'center'
  },
  'article-prompt-text': {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.4)',
    marginLeft: 8
  },
  'article-faq-container': {
    marginVertical: 4,
    marginHorizontal: 12,
    paddingTop: 12,
    marginBottom: 20,
    paddingBottom: 4,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: '#e8e8e8',
    borderStyle: 'solid',
    marginTop: 12
  },
  'article-faq-container-top12': {
    marginTop: 12,
    marginHorizontal: 0
  },
  'article-faq-title': {
    flexWrap: 'wrap',
    lineHeight: 20,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  'article-faq-item': {
    flexWrap: 'wrap',
    marginTop: 12,
    color: '#4080ee',
    lineHeight: 20
  },
  'article-faq-item__disabled': {
    color: 'rgba(0, 0, 0, 0.26)'
  },
  'article-wrapper': {
    minHeight: 20,
    width: '100%'
  },
  'article-summary': {
    position: 'relative',
    overflow: 'hidden',
    paddingVertical: 8,
    paddingHorizontal: 12
  },
  'article-gradient': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 40,
    overflow: 'hidden'
  },
  'article-btn': {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 12,
    lineHeight: 16,
    color: '#EE4D2D',
    borderTopColor: 'rgba(0, 0, 0, 0.09)',
    borderTopWidth: StyleSheet.hairlineWidth,
    borderStyle: 'solid'
  },
  'article-btn-text': {
    color: '#EE4D2D',
    fontSize: 14,
    lineHeight: 16
  },
  'article-arrow': {
    flexDirection: 'row',
    marginLeft: 4
  },
  'article-popup-content-container': {
    height: 'auto',
    paddingTop: 40,
    paddingHorizontal: 12,
    overflow: 'hidden'
  },
  'article-popup-content': {
    margin: 0,
    padding: 0,
    paddingBottom: 24,
    flex: undefined
  },
  'article-detail-content': {},
  'article-supporting-message': {
    marginTop: 12
  },
  'article-supporting-message__bottom': {
    marginBottom: 18
  },
  'article-faq-item-ui-optimisation-recommender': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1,
    marginTop: 0,
    paddingVertical: 12
  }),
  'article-faq-item-container-ui-optimisation-recommender': {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomColor: 'rgba(0, 0, 0, 0.09)',
    borderBottomWidth: StyleSheet.hairlineWidth
  },
  'article-faq-item-icon-ui-optimisation-recommender': {
    width: 12,
    height: 12,
    marginLeft: 8,
    flexShrink: 0
  },
  'article-faq-container-ui-optimisation-recommender': {
    borderTopWidth: 0,
    marginVertical: 0,
    marginHorizontal: 0,
    marginBottom: 0,
    paddingHorizontal: 0,
    paddingVertical: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 12
  },
  'article-faq-title-ui-optimisation-recommender': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.54)',
    paddingVertical: 12
  }),
  'article-faq-title-container-ui-optimisation-recommender': {
    borderBottomColor: 'rgba(0, 0, 0, 0.09)',
    borderBottomWidth: StyleSheet.hairlineWidth
  },
  'article-popup-content-container-ui-optimisation-table-modal': {
    paddingHorizontal: 0
  },
  'article-faq-container-ui-optimisation-table': {
    marginHorizontal: 12
  }
});
export default styles;